const sv = {
  // HttpClient
  'error.mustLogIn': 'Du måste logga in',
  'error.somethingWentWrong': 'Något gick fel, pröva igen',

  // Modal
  'modal.close': 'Stäng',

  // Login
  'login.heading': 'Ange din email för att logga in',
  'login.emailLabel': 'Email',
  'login.emailPlaceholder': 'example@email.com',
  'login.submitSending': 'Skickar...',
  'login.submitButton': 'Skicka inloggnings länk',
  'login.signUpLink': 'Registrera dig',
  'login.support': 'Behöver du hjälp?',
  'login.error': 'Ett fel uppstod',

  // SignUp
  'signUp.heading': 'Registrera dig',
  'signUp.mobileWarningTitle': 'VIKTIGT',
  'signUp.mobileWarningHeading': 'Använd datorn',
  'signUp.mobileWarningText':
    '{appName} är anpassat för att fungera på dator. Registrera dig här. Logga in på din dator för att använda programmet.',
  'signUp.nameLabel': 'Namn',
  'signUp.namePlaceholder': 'Förnamn Efternamn',
  'signUp.emailLabel': 'Email',
  'signUp.emailPlaceholder': 'example@email.com',
  'signUp.termsCheckbox': 'Jag godkänner {appName}s',
  'signUp.termsLink': 'användarvillkor',
  'signUp.marketingCheckbox':
    'Jag godkänner att ta emot e-post med information och erbjudanden från {domain}',
  'signUp.submitRegistering': 'Registrerar...',
  'signUp.submitButton': 'Registrera',
  'signUp.signInLink': 'Logga in',
  'signUp.support': 'Behöver du hjälp?',
  'signUp.successToast': 'Du är nu registrerad på {domain}',
  'signUp.error': 'Ett fel uppstod',

  // Projects
  'projects.title': 'Mina ritningar',
  'projects.promoText': 'Rita så mycket du vill',
  'projects.promoSubtext':
    'Skapa fritt antal ritningar och exportera till .pdf',
  'projects.promoPrice': '49 kr/mån (ange rabattkod RITABYGGLOV50)',
  'projects.upgradeButton': 'Prenumerera',
  'projects.newProjectFirstTime': 'Skapa din första ritning',
  'projects.newProject': 'Skapa ny ritning',
  'projects.subscribeToCreateMore': 'Prenumerera för att skapa fler ritningar',
  'projects.newProjectButton': '+ Ny ritning',
  'projects.createdAt': 'Skapad {date}',
  'projects.updatedAt': 'Uppdaterad {date}',
  'projects.scaleAndFormat': '{scale}, {format}',
  'projects.viewButton': 'Visa',
  'projects.editButton': 'Ändra',
  'projects.copyButton': 'Kopiera',
  'projects.deleteButton': 'Radera',
  'projects.showAsList': 'Visa som lista',
  'projects.showAsCards': 'Visa som kort',
  'projects.moreActions': 'Fler åtgärder',

  // CookieBanner
  'cookieBanner.title': 'Tredjepartskakor',
  'cookieBanner.text':
    '{appName} samlar in data från användare för att förbättra tjänsten. Data samlas in via tredjepart och delas aldrig med andra företag eller säljs. Syftet är enbart utveckling av tjänsten.',
  'cookieBanner.accept': 'Acceptera',
  'cookieBanner.reject': 'Avvisa',
  'cookieBanner.readMore': 'Läs mer i våra',
  'cookieBanner.termsLink': 'användarvillkor',

  // PSABanner
  'psaBanner.message':
    'Tekniska problem hos en tjänsteleverantör orsakar just nu felaktiga format vid export till PDF. Åtgärdsarbete pågår.',

  // ErrorFallback
  'error.title': 'Något gick fel',
  'error.description':
    'Vi påträffade ett oväntat fel. Ditt arbete är säkert och vi har blivit informerade om problemet. Försök att uppdatera sidan.',
  'error.contactInfo': 'Om problemet kvarstår, vänligen kontakta support på',
  'error.reloadButton': 'Uppdatera sidan',
  'error.retryButton': 'Försök igen',

  // UserSettings
  'userSettings.title': 'Kontoinställningar',
  'userSettings.backLink': '\u2190 Tillbaka',
  'userSettings.accountInfo': 'Kontoinformation',
  'userSettings.memberSince': 'Medlem sedan {date}',
  'userSettings.subscription': 'Prenumeration',
  'userSettings.subscriptionStatus': 'Din prenumeration är: {status}',
  'userSettings.subscriptionActive': 'Aktiv',
  'userSettings.subscriptionTrialing': 'Provperiod',
  'userSettings.subscriptionCancelsAt': 'Avslutas: {date}',
  'userSettings.subscriptionRenewsAt': 'Nästa förnyelse sker: {date}',
  'userSettings.noNoticeperiod': '{appName} har ingen uppsägningstid.',
  'userSettings.pastSubscriptions': 'Tidigare prenumerationer',
  'userSettings.pastSubscriptionRow': '{start} \u2013 {end} ({status})',
  'userSettings.pastSubscriptionCanceled': 'Avslutad',
  'userSettings.manageSubscription': 'Hantera',
  'userSettings.cookieConsent': 'Webb-kakor för analys',
  'userSettings.cookieConsentDescription':
    '{appName} använder icke-obligatoriska kakor för att förbättra produkten. Välj om du vill godkänna eller stänga av dessa här. Läs mer i våra <termsLink>användarvillkor</termsLink>.',
  'userSettings.disableCookies': 'Stäng av',
  'userSettings.enableCookies': 'Godkänn',
  'userSettings.cookiesDisabledToast': 'Analys-kakor har stängts av.',
  'userSettings.cookiesEnabledToast': 'Analys-kakor har satts på.',
  'userSettings.marketingConsent': 'Medgivande marknadsföring',
  'userSettings.marketingConsentDescription':
    '{appName} skickar e-post till de användare som godkänt mottagande av sådana.',
  'userSettings.marketingConsentEnabled':
    'Du tar nu emot marknadsföring via e-post.',
  'userSettings.marketingConsentDisabled':
    'Ditt medgivande för marknadsföring har tagits tillbaka.',
  'userSettings.revokeMarketing': 'Dra tillbaka',
  'userSettings.approveMarketing': 'Godkänn',
  'userSettings.deleteAccount': 'Radera konto',
  'userSettings.deleteAccountDescription':
    'Radera ditt konto, alla ritningar, och all data vi lagrat om dig. Detta går inte att ångra.',
  'userSettings.deleteConfirmPrompt': 'Skriv {phrase} för att bekräfta:',
  'userSettings.confirmDeleteButton': 'Bekräfta radering',
  'userSettings.cancelButton': 'Avbryt',
  'userSettings.deleteButton': 'Radera',
  'userSettings.support': 'Frågor? Kontakta oss på {contactEmail}',
  'userSettings.activeSubscriptionNotice':
    'Du har en aktiv prenumeration. Avsluta den innan du raderar ditt konto.',
  'userSettings.language': 'Språk',
  'userSettings.languageDescription':
    'Välj vilket språk du vill använda i applikationen.',

  // Navbar
  'navbar.adminLabel': 'Admin:',
  'navbar.adminStart': 'Start',
  'navbar.adminProjects': 'Projekt',
  'navbar.adminUsers': 'Användare',
  'navbar.loggedInAs': 'Inloggad som: {name}',
  'navbar.signOut': 'Logga ut',
  'navbar.accountSettings': 'Kontoinställningar',

  // Export
  'export.subscribeButton': 'Prenumerera',
  'export.exportButton': 'Exportera till PDF',
  'export.successToast': 'Din ritning är nu exporterad',
  'export.errorToast': 'Något gick fel vid exportering',

  // ExportDialog
  'exportDialog.heading': 'Exportera ritning till PDF',
  'exportDialog.drawingHeadSection': 'Ritningshuvud',
  'exportDialog.drawingHeadInfo':
    'Denna information kommer med på ritningen vid export',
  'exportDialog.authorLabel': 'Namn / Org.nummer',
  'exportDialog.authorPlaceholder': 'Namn / Org.nummer',
  'exportDialog.dateLabel': 'Ritningsdatum',
  'exportDialog.datePlaceholder': 'Tidpunkt för utförande',
  'exportDialog.propertyLabel': 'Fastighetsbeteckning',
  'exportDialog.propertyPlaceholder': 'Fastighetsbeteckning',
  'exportDialog.formatSection': 'Ritningens format',
  'exportDialog.scaleLabel': 'Skala',
  'exportDialog.scalePlaceholder': 'Skala',
  'exportDialog.submitButton': 'Exportera till PDF',

  // NorthArrow
  'northArrow.hiddenToast': 'Dolde norrpil. Visa igen i inställningar.',
  'northArrow.hideButton': 'Dölj norrpil',

  // TitleBlock
  'titleBlock.hiddenToast': 'Dolde ritningshuvud. Visa igen i inställningar.',
  'titleBlock.hideButton': 'Dölj ritningshuvud',
  'titleBlock.fields.name': 'Ritningsnamn',
  'titleBlock.fields.drawingType': 'Ritningstyp',
  'titleBlock.fields.propertyReference': 'Fastighetsbeteckning',
  'titleBlock.fields.author': 'Ritad av',
  'titleBlock.fields.date': 'Datum',
  'titleBlock.fields.projectName': 'Projektnamn',
  'titleBlock.fields.propertyDesignation': 'Fastighetsbeteckning',
  'titleBlock.fields.yourName': 'Ditt namn',
  'titleBlock.formatAndScale': 'Format: {format} | Skala: {scale}',
  'titleBlock.createdWith': 'Skapad med {appName}',

  // RenderMap
  'renderMap.formatWarning':
    'Varning: Det importerade kartunderlagets format stämmer inte överens med ritningens format. Ändra ritningens format i inställnings-menyn, eller ladda upp ett nytt underlag.',

  // PolylineDimensions
  'polylineDimensions.flipSide': 'Klicka för att byta sida',

  // ResizeHandlers
  'resizeHandlers.radiusLabel': 'Radie {radius}',

  // Checklist
  'checklist.hideButton': 'Göm checklista',
  'checklist.showButton': 'Visa checklista',
  'checklist.readMore': '(läs mer)',

  // MobilePopup
  'mobilePopup.title': '{appName} kräver mus och tangentbord för att fungera',
  'mobilePopup.messageLine1':
    '{appName} kräver muspekare & tangentbord. Pekskrämar på surfplattor och mobiltelefoner stöds ej för nuvarande.',
  'mobilePopup.messageLine2': 'Logga in på en dator för att använda {appName}.',
  'mobilePopup.closeButton': 'Okej',

  // Watermark
  'watermark.text': 'Prenumerera för att ta bort vattenmärket',

  // Toasts (component)
  'toast.closeButton': 'stäng',
  'canvas.copyToast':
    '{count, plural, one {# element kopierat} other {# element kopierade}}',

  // TopMenu
  'topMenu.mapAndScale': 'Kartunderlag och skala',
  'topMenu.syncSaved': 'Alla ändringar sparade',
  'topMenu.syncSaving': 'Sparar ändringar...',
  'topMenu.syncUnsaved':
    '{count} osparade ändringar \u2013 försöker återansluta',
  'localStorageWarning.title': 'Lokal lagring är inaktiverad',
  'localStorageWarning.body':
    'Din webbläsare har inaktiverat lokal lagring. Det betyder att ändringar kan gå förlorade om fliken stängs innan de har synkroniserats med servern. Aktivera cookies och lokal lagring i dina webbläsarinställningar för att garantera att ditt arbete sparas.',
  'localStorageWarning.linkText': 'Läs mer om hur du aktiverar lokal lagring',
  'topMenu.syncStalled':
    'Dina ändringar synkroniseras inte – kontrollera din anslutning.',

  // Settings (canvas settings panel)
  'settings.importMapTitle': 'Importera underlag',
  'settings.importMapText':
    'Ladda upp ett kartunderlag i pdf, png eller jpeg för din ritning. Filstorlek: max 10 MB.',
  'settings.importMapReadMore': 'Läs mer om importer',
  'settings.currentFile': 'Vald fil: {filename}',
  'settings.deleteFile': 'Radera',
  'settings.unitSystemTitle': 'Enhetssystem',
  'settings.unitSystemText':
    'Måttenheter för mått, skalor och pappersformat i denna ritning',
  'settings.unitSystemMetric': 'Metersystem',
  'settings.unitSystemImperial': 'Fot och tum',
  'settings.lengthFormatMeters': 'Meter (5,05 m)',
  'settings.lengthFormatMillimeters': 'Millimeter (5050 mm)',
  'settings.lengthFormatFeetInches': 'Fot och tum (24\'-6")',
  'settings.lengthFormatDecimalFeet': 'Decimalfot (24.5 ft)',
  'settings.scaleTitle': 'Ritningens skala',
  'settings.scaleText': 'Skalan för detta ritningsdokument',
  'settings.scaleReadMore': 'Läs mer om skala',
  'settings.formatTitle': 'Ritningens format',
  'settings.formatText': 'Formatet för detta ritningsdokument',
  'settings.titleBlockSectionTitle': 'Ritningshuvud',
  'settings.titleBlockSectionText':
    'Välj om ritningshuvud och norrpil ska visas på ritningen',
  'settings.northArrowLabel': 'Norrpil',
  'settings.titleBlockLabel': 'Ritningshuvud',
  'settings.uploadSuccess': 'Ditt kartunderlag är nu uppdaterad.',
  'settings.uploadError': 'Det gick inte lägga till kartunderlag',

  'pdfPagePicker.title': 'Välj sida att importera',
  'pdfPagePicker.page': 'Sida {page}',
  'pdfPagePicker.rotateLeft': '↺ Rotera moturs',
  'pdfPagePicker.rotateRight': '↻ Rotera medurs',
  'pdfPagePicker.import': 'Importera',
  'pdfPagePicker.importing': 'Importerar...',
  'pdfPagePicker.back': 'Tillbaka',

  // Page formats
  'format.groupInternational': 'Internationellt (ISO)',
  'format.groupUS': 'USA',
  'format.A3_LANDSCAPE': 'A3 Liggande',
  'format.A3_PORTRAIT': 'A3 Stående',
  'format.A4_LANDSCAPE': 'A4 Liggande',
  'format.A4_PORTRAIT': 'A4 Stående',
  'format.LETTER_LANDSCAPE': 'Letter Liggande',
  'format.LETTER_PORTRAIT': 'Letter Stående',
  'format.TABLOID_LANDSCAPE': 'Tabloid Liggande',
  'format.TABLOID_PORTRAIT': 'Tabloid Stående',
  'format.ARCH_C_LANDSCAPE': 'Arch C Liggande',
  'format.ARCH_C_PORTRAIT': 'Arch C Stående',
  'format.ARCH_D_LANDSCAPE': 'Arch D Liggande',
  'format.ARCH_D_PORTRAIT': 'Arch D Stående',
  'format.short.A3': 'A3',
  'format.short.A4': 'A4',
  'format.short.LETTER': 'Letter',
  'format.short.TABLOID': 'Tabloid',
  'format.short.ARCH_C': 'Arch C',
  'format.short.ARCH_D': 'Arch D',

  // Toolbar
  'toolbar.pan': 'Panorera',
  'toolbar.select': 'Markera',
  'toolbar.text': 'Text',
  'toolbar.line': 'Linje',
  'toolbar.rect': 'Rektangel',
  'toolbar.dimension': 'Måttlinje',
  'toolbar.perpendicularGuide': 'Vinkelrät hjälplinje',
  'toolbar.showAngles': 'Visa vinklar',
  'toolbar.addElement': 'Lägg till',
  'toolbar.endLine': 'Avsluta linje',
  'toolbar.contextPanSpace': 'Tryck och dra med musen för att panorera.',
  'toolbar.contextPanTip':
    'Tips: Du kan även panorera runt genom att hålla in mellanslag.',
  'toolbar.contextAddRect': 'Tryck för att lägga till en rektangel.',
  'toolbar.contextAddText': 'Tryck för att lägga till en text-ruta.',
  'toolbar.contextAddPolylineFirst':
    'Placera linjens startpunkt med muspekaren.',
  'toolbar.contextAddPolyline':
    'Lägg till fler punkter genom att klicka. Avsluta med Escape.',
  'toolbar.contextAddDimensionFirst':
    'Tryck flera gånger för att lägga till måttsättning.',
  'toolbar.contextEditPolyline':
    'Tips: Dra i de blå punkterna för att editera linjen.',
  'toolbar.contextEditText':
    'Dubbelklicka för att editera texten, avmarkera med Escape-knappen.',
  'toolbar.contextEditingText':
    'Skriv text i rutan. Avmarkera med Escape-knappen.',
  'toolbar.contextSelect':
    'Välj ett verktyg för att lägga till ett nytt objekt.',
  'toolbar.symbolTriangle': 'Triangel',
  'toolbar.symbolTrapezoid': 'Trapets',
  'toolbar.symbolAngle': 'Vinkel',
  'toolbar.symbolGeneralWell': 'Brunn generell symbol',
  'toolbar.symbolWell': 'Brunn',
  'toolbar.symbolDrillHole': 'Borrhål',
  'toolbar.symbolThreeChamberWell': 'Trekammarbrunn',
  'toolbar.fixtureWindowPlan': 'Fönster planritning',
  'toolbar.fixtureWindowElevation': 'Fönster fasadritning',
  'toolbar.fixtureWindowElevationOpenable': 'Öppningsbart fönster fasadritning',
  'toolbar.fixtureDoorPlan': 'Dörr planritning',
  'toolbar.fixtureDoorElevation': 'Dörr fasadritning',
  'toolbar.fixtureDoubleDoorPlan': 'Dubbeldörr planritning',
  'toolbar.fixtureDoubleDoorElevation': 'Dubbeldörr fasadritning',
  'toolbar.fixtureSlidingDoorPlan': 'Skjutdörr planritning',
  'toolbar.fixtureSlidingDoorElevation': 'Skjutdörr fasadritning',
  'toolbar.fixtureRoofAngle': 'Taklutning',
  'toolbar.fixtureStraightStairPlan': 'Rak trappa',
  'toolbar.fixtureDoubleStairPlan': 'Dubbel trappa',
  'toolbar.fixtureCornerStairPlan': 'Vinkeltrappa',
  'toolbar.fixtureUStairPlan': 'U-trappa',
  'toolbar.presetWaterClosetPlan': 'WC-stol',
  'toolbar.presetSinkPlan': 'Tvättställ',
  'toolbar.presetBathTubPlan': 'Badkar',
  'toolbar.presetChairPlan': 'Stol',
  'toolbar.presetTableAndChairsPlan': 'Bord och stolar',

  // Controls / PropertyGroups
  'controls.widthAndHeight': 'Bredd och höjd',
  'controls.dimensions': 'Mått',
  'controls.height': 'Höjd',
  'controls.alignLeft': 'Vänsterjusterad',
  'controls.alignCenter': 'Centrerad',
  'controls.alignRight': 'Högerjusterad',
  'controls.mirrorHorizontal': 'Spegla horisontellt',
  'controls.mirrorVertical': 'Spegla vertikalt',
  'controls.patternNone': 'Inget mönster',
  'controls.patternWhiteFill': 'Vit fyllnad',
  'controls.patternDiagonalHatch': 'Diagonal skraffering',
  'controls.patternDots': 'Prickar',
  'controls.patternBrick1': 'Tegel 1',
  'controls.patternBrick2': 'Tegel 2',
  'controls.patternRoofTiles': 'Takpannor',
  'controls.patternVerticalWood': 'Vertikal träpanel',
  'controls.patternHorizontalWood': 'Horisontell träpanel',
  'controls.patternSizeSmall': 'Litet mönster',
  'controls.patternSizeMedium': 'Medelstort mönster',
  'controls.patternSizeLarge': 'Stort mönster',
  'controls.patternDarkGrey': 'Mörkgrå',
  'controls.patternLightGrey': 'Ljusgrå',
  'controls.patternBlack': 'Svart',
  'controls.patternRed': 'Röd',
  'controls.patternOrange': 'Orange',
  'controls.patternYellow': 'Gul',
  'controls.patternGreen': 'Grön',
  'controls.patternBlue': 'Blå',
  'controls.patternTitle': 'Mönster',
  'controls.textColorTitle': 'Textfärg',
  'controls.strokeColorTitle': 'Linjefärg',
  'controls.strokeColorNone': 'Ingen linjefärg',
  'controls.strokeTitle': 'Linjeinställningar',
  'controls.dimensionsTitle': 'Dimensioner',
  'controls.smallDimensions': 'Små dimensioner',
  'controls.largeDimensions': 'Störst dimensioner',
  'controls.strokeSmall': 'Liten bredd',
  'controls.strokeLarge': 'Större bredd',
  'controls.rotation': 'Rotation',
  'controls.fontSize': 'Textstorlek',
  'controls.textAlign': 'Textjustering',
  'controls.width': 'Bredd',
  'controls.length': 'Längd',
  'controls.showAllSegments': 'Visa alla längder',
  'controls.pointRatio': 'Spetsposition',
  'controls.reorderTitle': 'Ändra ordning',
  'controls.moveToTop': 'Flytta överst',
  'controls.moveUp': 'Flytta upp',
  'controls.moveDown': 'Flytta ner',
  'controls.moveToBottom': 'Flytta underst',
  'controls.deleteButton': 'Ta bort',
  'controls.copyButton': 'Kopiera',
  'controls.groupButton': 'Gruppera',
  'controls.groupButtonTitle': 'Gruppera dessa element (CTRL + G)',
  'controls.ungroupButton': 'Avgruppera',
  'controls.ungroupButtonTitle': 'Avgruppera dessa element (CTRL + SHIFT + G)',
  'controls.strokeWidthThin': 'Smal linje',
  'controls.strokeWidthMedium': 'Mediumtjock linje',
  'controls.strokeWidthThick': 'Tjock linje',
  'controls.strokeWidthExtraThick': 'Extra tjock linje',
  'controls.thicknessExact': 'Exakt tjocklek i meter',
  'controls.thicknessExactMillimeters': 'Exakt tjocklek i millimeter',
  'controls.thicknessExactImperial': 'Exakt tjocklek i tum',
  'controls.polylineStrokeWidthSmall': 'Mindre bredd',
  'controls.polylineStrokeWidthMedium': 'Medium bredd',
  'controls.fontSizeSmall': 'Liten text',
  'controls.fontSizeMedium': 'Mellanstor text',
  'controls.fontSizeLarge': 'Stor text',
  'controls.fontSizeExtraLarge': 'Extra stor text',
  'controls.dimensionNone': 'Inga dimensioner',
  'controls.dimensionMedium': 'Medel dimensioner',
  'controls.dimensionLarge': 'Stora dimensioner',
  'controls.strokeDashSolid': 'Heldragen linje',
  'controls.strokeDashDotted': 'Prickad linje',
  'controls.strokeDashDashed': 'Streckad linje',
  'controls.strokeDashDotDashed': 'Streckad linje',
  'controls.strokeDashOutlined': 'Konturlinje',
  'controls.strokeDashDashedAlt': 'Streckad linje alternativ',

  // New Project Modal
  'newProject.title': 'Ny ritning',
  'newProject.subtitle': 'Skapa en ny ritning i A3 eller A4 format',
  'newProject.nameLabel': 'Ritningens namn',
  'newProject.typeLabel': 'Ritningstyp',
  'newProject.unitSystemLabel': 'Enhetssystem',
  'newProject.scaleLabel': 'Ritningens skala',
  'newProject.scaleHint': 'Du kan ändra skala senare.',
  'newProject.scaleReadMore': 'Läs mer om skala och vilken du bör välja',
  'newProject.formatLabel': 'Ritningens format',
  'newProject.formatHint':
    'Formatet bör stämma överrens med det eventuella kartunderlag du importerar',
  'newProject.submitButton': 'Skapa ritning',
  'newProject.submittingButton': 'Skapar ritning...',
  'newProject.comingSoon': 'Under utveckling',
  'drawingType.sitePlan': 'Situationsplan',
  'drawingType.sitePlanText': 'Visar tomten i fråga med den aktuella åtgärden.',
  'drawingType.facadeDrawing': 'Fasadritning',
  'drawingType.facadeDrawingText': 'Visar husets fasader rakt framifrån.',
  'drawingType.other': 'Tom ritning',
  'drawingType.otherText': 'Rita helt själv utan mall eller checklista.',
  'drawingType.floorPlan': 'Planritning',
  'drawingType.floorPlanText': 'Vy ovanifrån med ingående delar.',
  'scaleDescription.1:1000': 'För översiktskarta och stora områden',
  'scaleDescription.1:800': 'För större situationsplaner',
  'scaleDescription.1:500': 'Vanligt för situationsplaner',
  'scaleDescription.1:400': 'Vanligt för situationsplaner',
  'scaleDescription.1:250': 'Bra för mindre situationsplaner',
  'scaleDescription.1:200': 'För plan- och fasadritningar',
  'scaleDescription.1:100': 'För plan- och fasadritningar',
  'scaleDescription.1:50': 'För detaljerade plan- och fasadritningar',

  // Delete Project Modal
  'deleteProject.title': 'Radera ritning',
  'deleteProject.confirm': 'Är du säker på att du vill radera ritningen?',
  'deleteProject.yes': 'Ja, radera',
  'deleteProject.no': 'Avbryt',
  'deleteProject.loading': 'Tar bort ritning',

  // Edit Project Modal
  'editProject.title': 'Ändra ritning',
  'editProject.nameLabel': 'Namn',
  'editProject.scaleLabel': 'Ritningens skala',
  'editProject.scaleHint': 'Vilken skala är rätt?',
  'editProject.scaleReadMore': 'Läs mer',
  'editProject.formatLabel': 'Ritningens format',
  'editProject.submitButton': 'Spara',
  'editProject.submittingButton': 'Sparar...',

  // Copy Project Modal
  'copyProject.title': 'Kopiera ritning',
  'copyProject.confirm': 'Vill du kopiera {name}?',
  'copyProject.description':
    'En ny ritning kommer att skapas med alla ändringar och checklistan.',
  'copyProject.submitButton': 'Ja, kopiera',
  'copyProject.loading': 'Kopierar ritning',
  'copyProject.cancelButton': 'Avbryt',

  // Subscription Modal
  'subscription.monthly': 'Månadsvis',
  'subscription.yearly': 'Årsvis',
  'subscription.perMonth': '/ mån',
  'subscription.perYear': '/ år',
  'subscription.discount': '(-{percent}%)',
  'subscription.selectButton': 'Välj',
  'subscription.paymentLine1': 'Betalning säkert via Stripe.',
  'subscription.paymentLine2': 'Utan bindningstid, avsluta när du vill.',
  'subscription.paymentLine3': 'Läs våra',
  'subscription.paymentTermsLink': 'användarvillkor',
  'subscription.removeWatermarkDescription':
    'Prenumerera för att ta bort vattenmärket och kunna exportera dina ritningar till PDF.',
  'subscription.questionsContact':
    'Frågor om prenumeration? Kontakta oss på {contactEmail}',
  'subscription.noUrlError': 'Ingen URL mottagen från servern',
  'subscription.errorToast': 'Något gick fel vid prenumeration',

  // Subscription Cancel
  'subscriptionCancel.title': 'Abonnemang avbrutet',
  'subscriptionCancel.message':
    'Du har avbrutit processen för att starta ett abonnemang. Du är alltid välkommen att teckna ett abonnemang i framtiden!',
  'subscriptionCancel.goHome': 'Gå till startsidan',

  // Subscription Success
  'subscriptionSuccess.title': 'Prenumeration aktiverad!',
  'subscriptionSuccess.text1':
    'Du har nu tillgång till prenumerationsfunktionerna.',
  'subscriptionSuccess.text2': 'Vid frågor, kontakta oss på {contactEmail}.',
  'subscriptionSuccess.text3':
    'Vi som grundat {appName} läser och svarar på alla mail. Vi vill såklart höra vad du tycker, och hur ditt projekt går.',
  'subscriptionSuccess.text4':
    'Din prenumeration förnyas automatiskt. För att avsluta prenumerationen: gå till "Kontoinställningar" och tryck på "Hantera" under prenumerationssektionen.',
  'subscriptionSuccess.goHome': 'Gå till startsidan',

  // Subscription Management Link
  'subscriptionLink.manage': 'Hantera prenumeration',
  'subscriptionLink.expiresAt': 'Nuvarande prenumerationen upphör {date}',

  // Plans
  'plans.free.title': 'Gratis',
  'plans.free.description':
    'Testa vad {appName} är kapabelt till utan att betala något.',
  'plans.regular.title': 'Prenumeration',
  'plans.regular.description':
    'Importera kartor, skapa situationsplaner, relationsritningar, eller enkla fasadritningar direkt i webbläsaren.',
  'plans.professional.title': 'Professionell',
  'plans.professional.description':
    'Importera kartor, skapa situationsplaner, relationsritningar, eller enkla fasadritningar direkt i webbläsaren.',
  'plans.feature.unlimitedDrawings': 'Oändligt antal ritningar',
  'plans.feature.exportPdf': 'Exportera till pdf',
  'plans.feature.ownLogo': 'Egen ritningslogotyp',
  'plans.feature.collaboration': 'Samarbetsläge online',
  'plans.feature.support247': 'Support 24/7',
  'plans.feature.noWatermark': 'Inget vattenmärke',

  // QuickHelp
  'quickHelp.title': 'Snabbguide {appName}',
  'quickHelp.readMorePre': 'Läs',
  'quickHelp.readMoreLink': 'användarguide',
  'quickHelp.readMorePost': 'för utförlig användarmanual och guide.',
  'quickHelp.contact': 'Kontakta oss på {contactEmail} vid frågor.',
  'quickHelp.toolsHeading': 'Verktygen',
  'quickHelp.panLabel': 'Panorera',
  'quickHelp.panDesc':
    'Klicka med muspekaren, hålle inne och dra. Snabbknapp: <kbd>MELLANSLAG</kbd>.',
  'quickHelp.selectLabel': 'Markera',
  'quickHelp.selectDesc':
    'Tryck på ett objekt för att markera det. Dra för att flytta det. Dra i de blå handtagen för att editera objektet. Snabbknapp: <kbd>V</kbd>.',
  'quickHelp.textLabel': 'Text',
  'quickHelp.textDesc':
    'Tryck för att skapa textrutor. Markera texten i rutan och använd tangentbordet för att ändra den. Snabbknapp: <kbd>T</kbd>.',
  'quickHelp.lineLabel': 'Linje',
  'quickHelp.lineDesc':
    'Klicka för att för att lägga till punkter. Håll nere <kbd>SHIFT</kbd> för att låsa linjen till fasta vinklar. Avsluta linjen med <kbd>ESCAPE</kbd>. Snabbknapp: <kbd>L</kbd>.',
  'quickHelp.rectLabel': 'Rektangel',
  'quickHelp.rectDesc':
    'Tryck för att placera ut en rektangel med rätvinkliga hörn. Snabbknapp: <kbd>R</kbd>.',
  'quickHelp.dimensionLabel': 'Måttlinje',
  'quickHelp.dimensionDesc':
    'Markera ut mått på ritningen. Ritas på samma sätt som vanliga linjer, men med utseende lämpligt för måttsättning. Snabbknapp: <kbd>M</kbd>.',
  'quickHelp.addLabel': 'Lägg till',
  'quickHelp.addDesc':
    'Lägg till dörrar, fönster eller ritningsymboler. Tryck på lägg till och välj symbol.',
  'quickHelp.actionsHeading': 'Vanliga handlingar',
  'quickHelp.zoomHeading': 'Zooma',
  'quickHelp.zoomDesc':
    'Zooma genom att dra i zoom-handtaget i skärmens nedre högra hörn. Eller genom <kbd>CTRL + Scroll-hjul</kbd>. Eller genom att "nypa" på laptopens touchpad.',
  'quickHelp.deleteHeading': 'Radera element',
  'quickHelp.deleteDesc':
    'Använd: <kbd>BACKSPACE</kbd> eller <kbd>DELETE</kbd>',
  'quickHelp.undoHeading': 'Ångra',
  'quickHelp.undoDesc':
    'Använd: <kbd>CTRL + Z</kbd> för att ångra. Använd: <kbd>SHIFT + CTRL + Z</kbd> för att stega framåt igen.',
  'quickHelp.copyHeading': 'Kopiera',
  'quickHelp.copyDesc':
    'Använd: <kbd>CTRL + C</kbd> för att kopiera markerade element till urklipp. Använd: <kbd>CTRL + V</kbd> för att klistra in. Använd: <kbd>CTRL + D</kbd> för att duplicera på plats.',
  'quickHelp.groupHeading': 'Gruppera element',
  'quickHelp.groupDesc':
    'Markera 2 eller fler element och använd <kbd>CTRL + G</kbd> för att gruppera dem. Använd <kbd>SHIFT + CTRL + G</kbd> för att avgruppera. Dubbelklicka på en grupp för att redigera dess innehåll, tryck <kbd>ESC</kbd> för att avsluta.',
  'quickHelp.snapLinesHeading': 'Hjälplinjer',
  'quickHelp.snapLinesDesc':
    'Hjälplinjer underlättar placering av objekt i linje med varandra. Inaktivera hjälplinjer genom att hålla nere <kbd>CTRL</kbd> på windows, eller <kbd>CMD</kbd> Mac. Vid tillägg av nya linjer, håll nere <kbd>SHIFT</kbd> för att låsa till fasta vinklar. Visa/dölj alla hjälplinjer med <kbd>CMD</kbd>/<kbd>CTRL</kbd> + <kbd>SHIFT</kbd> + <kbd>O</kbd>.',
  'quickHelp.importMapHeading': 'Importera kartunderlag',
  'quickHelp.importMapDesc':
    'Tryck på knappen importera kartunderlag uppe till vänster och ladda upp ditt material. Tänk på att välja samma skala (ex. 1:400) och format (ex. A3 landskap) på ritning och material.',
  'quickHelp.exportHeading': 'Exportera',
  'quickHelp.exportDesc':
    'Tryck på knappen exportera uppe i högra hörnet för att ladda ned ritningen som PDF.',
  'quickHelp.saveHeading': 'Spara ändringar',
  'quickHelp.saveDesc':
    '{appName} sparar alla ändringar automatiskt. Tappar din dator internetuppkoppling kommer {appName} att spara ändringarna lokalt i din webbläsare tills uppkopplingen återupprättas. För att inte förlora arbete, se till att ha stabil internetuppkoppling.',

  // Admin
  'admin.projects.title': 'Projekt',
  'admin.projects.total': 'Totalt antal projekt: {count}',
  'admin.projects.loading': 'Laddar projekt...',
  'admin.pagination.prev': 'Föregående',
  'admin.pagination.next': 'Nästa',
  'admin.pagination.pageOf': 'Sida {page} av {totalPages}',
  'admin.projects.nameHeader': 'Namn',
  'admin.projects.emailHeader': 'Email',
  'admin.projects.createdHeader': 'Skapad',
  'admin.projects.updatedHeader': 'Senast uppdaterad',
  'admin.projects.changesCount': 'Ändringar',
  'admin.projects.actions': 'Åtgärder',
  'admin.projects.noChangesToClear': 'Inga ändringar att rensa',
  'admin.projects.clearChanges': 'Rensa gamla ändringar',
  'admin.projects.fetchError': 'Något gick fel när projekt skulle hämtas',
  'admin.userProjects.title': 'Projekt av {name}',
  'admin.userProjects.titleFallback': 'Projekt av användare',
  'admin.userProjects.total': 'Totalt antal projekt: {count}',
  'admin.userProjects.site': 'Sajt: {site}',
  'admin.userProjects.loading': 'Laddar projekt...',
  'admin.userProjects.fetchError': 'Något gick fel när projekt skulle hämtas',
  'admin.userProjects.empty': 'Den här användaren har inga projekt.',
  'admin.garbageCollect.title': 'Rensa gamla ändringar',
  'admin.garbageCollect.confirmText':
    'Är du säker på att du vill rensa gamla ändringar för projektet "{name}"?',
  'admin.garbageCollect.changesCount': 'Detta projekt har {count} ändringar.',
  'admin.garbageCollect.description':
    'Gamla versioner och temporära ändringar kommer att tas bort, men den senaste versionen av varje element behålls.',
  'admin.garbageCollect.warning': 'Obs: Denna åtgärd kan inte ångras.',
  'admin.garbageCollect.confirmButton': 'Ja, rensa',
  'admin.garbageCollect.loadingButton': 'Rensar ändringar...',
  'admin.garbageCollect.successToast': '{message} ({count} ändringar rensade)',
  'admin.copyProject.title': 'Kopiera projekt',
  'admin.copyProject.description':
    'En kopia av {name} kommer att skapas och tilldelas vald användare.',
  'admin.copyProject.assignLabel': 'Tilldela kopia till',
  'admin.copyProject.ownerOption': '{email} (ägare)',
  'admin.copyProject.adminOption': '{email} (admin)',
  'admin.copyProject.copyButton': 'Kopiera',
  'admin.copyProject.copyingButton': 'Kopierar...',
  'admin.copyProject.cancelButton': 'Avbryt',
  'admin.copyProject.successToast': 'Projektet kopierades',
  'admin.users.title': 'Användare',
  'admin.users.total': 'Totalt antal användare: {count}',
  'admin.users.actionHeader': 'Åtgärd',
  'admin.users.loading': 'Laddar användare...',
  'admin.users.fetchError': 'Något gick fel när användare skulle hämtas',
  'admin.users.deleteConfirm':
    'Är du säker på att du vill radera denna användare? Detta går inte att ångra.',
  'admin.users.deleteError': 'Något gick fel när användaren skulle raderas',
  'admin.users.nameHeader': 'Namn',
  'admin.users.emailHeader': 'Email',
  'admin.users.siteHeader': 'Sajt',
  'admin.users.createdHeader': 'Skapad',
  'admin.users.lastActiveHeader': 'Senast aktiv',
  'admin.users.activeDaysHeader': 'Aktiva dagar',
  'admin.users.subscriptionHeader': 'Prenumeration',
  'admin.users.deleteButton': 'Radera',
  'admin.users.statusActive': 'Aktiv',
  'admin.users.statusCanceled': 'Avbruten',
  'admin.users.statusIncomplete': 'Inkomplett',
  'admin.users.statusIncompleteExpired': 'Utgången inkomplett',
  'admin.users.statusPastDue': 'Förfallen',
  'admin.users.statusTrialing': 'Prövoperiod',
  'admin.users.statusUnpaid': 'Obetald',
  'admin.users.statusPaused': 'Pausad',
  'admin.users.subscriptionCancelAt': '(avslutas {date})',
  'admin.users.filterByStatus': 'Filtrera efter prenumerationsstatus',
  'admin.users.filterBySite': 'Filtrera efter sajt',
  'admin.users.search': 'Sök användare',
  'admin.users.searchPlaceholder': 'Sök namn eller email...',
  'admin.projects.filterByOwnerStatus': 'Ägarens prenumerationsstatus',
  'admin.projects.filterByOwnerEmail': 'Ägarens email',
  'admin.projects.filterEmailPlaceholder': 'Sök email...',
};

export default sv;
